import { render, staticRenderFns } from "./AdminSideBar.vue?vue&type=template&id=f3cc0eec&"
import script from "./AdminSideBar.vue?vue&type=script&lang=js&"
export * from "./AdminSideBar.vue?vue&type=script&lang=js&"
import style0 from "./AdminSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports